import { render, staticRenderFns } from "./Trends-Spec-Old.vue?vue&type=template&id=294d0a12&"
import script from "./Trends-Spec-Old.vue?vue&type=script&lang=js&"
export * from "./Trends-Spec-Old.vue?vue&type=script&lang=js&"
import style0 from "./Trends-Spec-Old.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports